import { urlParams, TEAMS_USER_IMPRESSION_SERVICE_ID } from "./../constants/AppConstants";
import { checkIsInsideIframe } from "../pages/utils/commonUtils";
import { app } from "@microsoft/teams-js";

function getAllUrlParams() {
    var allUrlParams = new URLSearchParams(window.location.search);
    var resourceObj = {};
    for (var key of allUrlParams.keys()) {
        resourceObj[key] = allUrlParams.get(key);
    }
    var resourceStr = JSON.stringify(resourceObj);
    return encodeURIComponent(resourceStr);
}
export let TeamsController = {
    service: "Teams",
    crmPhoneSearchSelect: true,
    landingPage: true,
    landingPagePathname: "/teams/landing",
    surveyFormUrl: "https://zfrmz.com/bFnoYZLikTl34Sg2ZVHI",
    doSurvey: true,
    contactsEnabled: true,
    sideBarExtend: {
        hideAutomationSideBar: true,
        hideVoiceSideBar: true,
        contactsSideBar: true,
    },
    authModal: {
        title: "Connect Microsoft Teams",
        content:
            "Integrate HelloSend with Teams to manage SMS, WhatsApp, and RCS conversations directly inside your workspace — no app switching required.",
    },
    UNIPILE_WHATSAPP_GALLERY: [
        {
            videoUrl: "https://www.youtube.com/embed/pH4vGpSc8i0",
        },
        {
            videoUrl: "",
        },
    ],
    init: function () {
        return new Promise((resolve, reject) => {
            if (checkIsInsideIframe()) {
                // Only initialize if inside an iframe (like in Teams)
                import("@microsoft/teams-js")
                    .then((teams) => {
                        teams.app
                            .initialize()
                            .then(() => {
                                teams.app.notifySuccess();
                                resolve();
                            })
                            .catch((error) => {
                                resolve(error);
                            });
                    })
                    .catch((error) => {
                        resolve(error);
                    });
            } else {
                resolve();
            }
        });
    },

    isCreditAccessible: function () {
        return new Promise((resolve, reject) => {
            if (app && checkIsInsideIframe()) {
                app.getContext().then((context) => {
                    if (["desktop", "web"].includes(context.app.host.clientType)) {
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                });
            } else {
                resolve(true);
            }
        });
    },

    getCustomAuthUrl: function (appProperties) {
        return new Promise((resolve, reject) => {
            const redirectUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?response_type=code&client_id=${
                appProperties?.leftServiceClientDetails?.clientId
            }&redirect_uri=https://api.oapps.xyz/rest/api/v2/redirect&state=${
                appProperties?.osyncId
            }::${TEAMS_USER_IMPRESSION_SERVICE_ID}::${TEAMS_USER_IMPRESSION_SERVICE_ID}::true&scope=${encodeURIComponent(
                "https://api.interfaces.records.teams.microsoft.com/user_impersonation offline_access"
            )}&access_type=offline&prompt=select_account`;
            resolve(redirectUrl);
        });
    },

    pricingLink: function (appProperties) {
        return new Promise((resolve, reject) => {
            const { hash, osyncId, domain } = appProperties;
            var leftServiceId = urlParams.get("leftServiceId");
            var leftServiceName = urlParams.get("service");
            var allUrlParams = getAllUrlParams();
            var redirectSendSMSFromModule = domain + "/persons/list";
            var hrefUrl = `/package/pricing?productId=102&groupName=OMNI_CHANNEL&domain=${domain}&hash=${hash}&leftServiceId=${leftServiceId}&osyncId=${osyncId}&leftServiceName=${leftServiceName}&urlParams=${allUrlParams}&redirectSendSMSFromModule=${redirectSendSMSFromModule}`;

            resolve(hrefUrl);
        });
    },
    /** URL query wins when set (task module / deep link); otherwise Teams host context. */
    getUserData: function (_isUserHashNeeded) {
        return new Promise((resolve) => {
            const fromUrl = {
                companyId: urlParams.get("companyId"),
                emailId: urlParams.get("email"),
                userId: urlParams.get("userId"),
                domain: urlParams.get("domain"),
            };

            const merge = (context) => {
                const tenantId = context?.user?.tenant?.id ?? null;
                const teamsUserId = context?.user?.id ?? null;
                const emailFromTeams = context?.user?.loginHint || context?.user?.userPrincipalName || null;

                const companyId = fromUrl.companyId || tenantId;
                const userId = fromUrl.userId || teamsUserId;
                const emailId = fromUrl.emailId || emailFromTeams;
                const domain = fromUrl.domain;

                return {
                    companyId,
                    userId,
                    companyOrgId: companyId,
                    domain,
                    emailId,
                };
            };

            const inTeamsShell = checkIsInsideIframe();
            if (app && inTeamsShell) {
                app.getContext()
                    .then((context) => resolve(merge(context)))
                    .catch(() => {
                        resolve(merge(null));
                    });
            } else {
                resolve(merge(null));
            }
        });
    },

    /** Microsoft Teams host frame context (team/channel/chat); null when not in Teams shell. */
    getContext: function () {
        return new Promise((resolve) => {
            const inTeamsShell = checkIsInsideIframe();
            if (app && inTeamsShell) {
                app.getContext()
                    .then((context) => resolve(context))
                    .catch(() => {
                        resolve(null);
                    });
            } else {
                resolve(null);
            }
        });
    },

    /**
     * Merges left-service id and Teams host context into the outbound SMS send body (CRM phone search / Teams tab).
     */
    injectLeftServiceData: async function (appProperties, body, selectedTeamsContact) {
        if (!body) {
            return;
        }
        const leftServiceId = appProperties?.leftServiceId ?? urlParams.get("leftServiceId");
        if (leftServiceId) {
            body.leftServiceId = leftServiceId;
        }
        const msgThreadIdFromUrl = urlParams.get("msgThreadId");
        const fromFromUrl = urlParams.get("from");
        const toFromUrl = urlParams.get("to");
        if (fromFromUrl && !body.from) {
            body.from = fromFromUrl;
        }
        if (toFromUrl && !body.to) {
            body.to = toFromUrl;
        }
        try {
            const context = await TeamsController.getContext();
            if (context?.team?.groupId) {
                body.serviceTeamId = context.team.groupId;
            }
            if (context?.channel?.id) {
                body.serviceChannelId = context.channel.id;
            }
            if (context?.chat?.id) {
                body.serviceChatId = context.chat.id;
            }
            if (!body.serviceConversationId && msgThreadIdFromUrl && context?.channel?.id) {
                body.serviceConversationId = `${context.channel.id};messageid=${msgThreadIdFromUrl}`;
            }
            if (!body.serviceConversationId) {
                body.serviceConversationId = context?.chat?.id || context?.channel?.id;
            }
        } catch (e) {
            console.warn("Could not get Teams context for send:", e);
        }
        if (selectedTeamsContact?.id) {
            body.associatedObjectId = selectedTeamsContact.id;
            body.associatedObjectType = "Contacts";
        }
    },

    defaultSettingValue: {
        emailNotification: {
            sendEmail: true,
            accountOwner: true,
        },
        userNotification: "true",
        sharedInbox: "user",
        contactAssignment: "crmLeadOwner",
    },
    getAssociatedObjectType: function () {
        return new Promise((resolve, reject) => {
            resolve("Contacts");
        });
    },
    getUrlParamsForRedirection: function (isNewWindow, appProperties) {
        return new Promise((resolve, reject) => {
            var redirectUrl = `leftServiceId=${appProperties.leftServiceId || urlParams.get("leftServiceId")}&service=teams&domain=org${
                appProperties.companyId
            }&userId=${appProperties.userId}&companyId=${appProperties.companyId}`;
            resolve(redirectUrl);
        });
    },
};
